import { render, staticRenderFns } from "./CanvasEditor.vue?vue&type=template&id=2b04d8bc"
import script from "./CanvasEditor.vue?vue&type=script&lang=ts"
export * from "./CanvasEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports